// Query statuses (from queries API)
const submittedStatuses = ['pending', 'submittedToJournalist', 'journalistPassed', 'insightsNotIncluded'];

const successfulStatuses = ['successful', 'pendingPublication', 'paidEditorial'];

// External effort statuses (different format from queries)
const externalEffortSubmittedStatuses = ['submitted to journalist', 'journalist passed', 'insights not included', 'paid editorial'];

const externalEffortSuccessfulStatuses = ['pending publication', 'successful placement', 'successful'];

export { submittedStatuses, successfulStatuses, externalEffortSubmittedStatuses, externalEffortSuccessfulStatuses };
